export default __webpack_public_path__ + "static/equipo-tom-Color-129dd7222cb17f90660b9d4215309e31.png";